import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaRocket,
  FaEye,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const DigitalMarketingVideoProductionInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Digital Marketing Video Production in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Amplify Your Campaigns</Subheading>}
        heading={
          <Heading>
            Digital Marketing{" "}
            <span tw="text-primary-500">Video Production</span> in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide professional digital marketing video
            production services in **Dubai**, crafting engaging,
            platform-optimized videos for social media, websites, and ad
            campaigns. Boost your brand’s reach and conversions with cinematic,
            high-impact content.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1616469829941-c7200edec809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional video shoot
          "https://images.unsplash.com/photo-1601506521941-ca8a9ea2f0db?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Creative video production
          "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Dynamic video content
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch Your Campaign"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Premier Digital Marketing Video Production in Dubai"
        description="We create videos that drive engagement and results."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Engaging Content",
            description:
              "Videos tailored for social media and digital platforms.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven success with Dubai’s leading brands.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Quick delivery for time-sensitive campaigns.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Audience Reach",
            description: "Content designed to maximize views and conversions.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Platform Optimization",
            description: "Customized for Instagram, YouTube, TikTok, and more.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "Full-Service Production",
            description: "From concept to post-production and analytics.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Digital Marketing Video Production Process"
        description={
          <Description>
            We craft high-impact digital marketing videos with a streamlined
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Strategy: Define your campaign goals and target audience.</li>
              <li>
                Creative: Develop scripts and storyboards for maximum impact.
              </li>
              <li>
                Filming: Use 4K equipment and professional crews for stunning
                visuals.
              </li>
              <li>
                Editing: Enhance with motion graphics, animations, and sound
                design.
              </li>
              <li>Delivery: Provide optimized videos for digital platforms.</li>
              <li>Analytics: Track performance and offer campaign insights.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1496559249665-c7e2874707ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Storyboarding session
          "https://images.unsplash.com/photo-1603729340594-9e0c31e0063b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Camera equipment closeup
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Video editing process
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Digital Marketing Video Wins in Dubai"
        description="Our videos have transformed digital campaigns."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Social Media Campaign",
            description: "Drove 10x engagement for a Dubai retailer.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Ad Performance",
            description: "Boosted conversions for a tech startup.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "96% approval from digital marketing clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Boost Your Reach?</Subheading>}
        heading="Digital Marketing Video Production in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for professional digital marketing video
            production services in Dubai. Get engaging, platform-optimized
            videos that elevate your campaigns—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1583217874484-9e3a5ee3dd5e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Dubai cityscape/skyline
          "https://images.unsplash.com/photo-1524649466382-c1c6b5b6e9cf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2574&q=80", // Creative marketing team
          "https://images.unsplash.com/photo-1551218372-a8dadaee604a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional camera equipment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
